export class GetDoorToDoorReportsByMonthRequest {
  public cmd: string = "get_door_to_door_reports_by_month";
  constructor(public majlis: string, public month: string, public year: string) { }
}
